// TODO: adjust this if 1DTP Regular(not BackAndLay) will ever come to production
import { propOr } from 'ramda';
import { createSelector } from 'reselect';

import { selectors as bootstrapSelectors } from '@ezugi/bootstrap';

const {
  configSelector,
} = bootstrapSelectors;

export const payoutsProgressSelector = createSelector(
  configSelector,
  propOr({}, 'payoutsProgress')
);

export const currentPayoutsProgressSelector = createSelector(
  payoutsProgressSelector,
  propOr({}, 'current')
);

export const statusPayoutsProgressSelector = createSelector(
  payoutsProgressSelector,
  propOr({}, 'status')
);
